import firebase from '@firebase/app';

export const sectionsTrainingList = (uidProfessor, uidTraining, callback) => {


  return firebase.firestore().collection("professors").doc(uidProfessor)
    .collection("sections").where("training", "==", uidTraining)
    // .orderBy("name", "asc")
    .get()
    .then((snapshot) => {
      let itens = []
      snapshot.forEach(doc => {
        //console.log(doc.id, '=>', doc.data());
        let section = doc.data();
        itens.push(doc.data())
      });
      callback(itens, true);
    }, (error) => {
      console.log('Error getting documents', error);
      callback(error, false);
    });

}



export const updateSectionFirebase = (uidProfessor, uidSection, section, callback) => {

  return firebase.firestore().collection("professors")
    .doc(uidProfessor)
    .collection("sections")
    .doc(uidSection)
    .update(section)
    .then(function (doc) {
      console.log("Document successfully written!");
      callback(doc, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

export const deleteSectionTraining = (uidProfessor, uidSection, callback) => {

  return firebase.firestore().collection("professors")
    .doc(uidProfessor)
    .collection("sections")
    .doc(uidSection).delete().then(function (response) {
      callback(response, true)
    }).catch(function (error) {
      callback(error, false)
    });
}

export const getAllSections = (uidProfessor, callback) => {

  return firebase.firestore()
    .collection("professors")
    .doc(uidProfessor)
    .collection("sections")
    .get()
    .then(function (querySnapshot) {
      let itens = []
      querySnapshot.forEach(function (doc) {
        // doc.data() is never undefined for query doc snapshots
        //console.log(doc.id, " => ", doc.data());
        let section = {
          id: doc.id,
          data: doc.data(),
        }
        itens.push(section)
      });
      callback(itens, true);
    })
    .catch(function (error) {
      console.log("Error getting documents: ", error);
      callback(error, false);
    });
}



// WEBPACK FOOTER //
// src/dao-firebase/section-daofirebae.js